import React, { createContext, useState, useContext, useEffect } from 'react';

// Create context
const CountryContext = createContext();

// Provider component
export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState(() => localStorage.getItem('countryCodes'));

  // Update country code and sync with localStorage
  const updateCountryCode = (newCode) => {
    if (!newCode) {
      localStorage.removeItem('countryCodes');
      setSelectedCountry(null);
    } else {
      localStorage.setItem('countryCodes', newCode);
      setSelectedCountry(newCode);
    }
  };

  // Keep selectedCountry in sync with localStorage even after login
  useEffect(() => {
    const checkForLocalStorageUpdate = () => {
      const stored = localStorage.getItem('countryCodes');
      if (stored !== selectedCountry) {
        setSelectedCountry(stored);
      }
    };

    // Check once on mount and then every 500ms
    checkForLocalStorageUpdate();
    const interval = setInterval(checkForLocalStorageUpdate, 500);

    return () => clearInterval(interval);
  }, [selectedCountry]);

  // Sync across tabs (optional)
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'countryCodes') {
        setSelectedCountry(event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <CountryContext.Provider value={{ selectedCountry, updateCountryCode, setSelectedCountry }}>
      {children}
    </CountryContext.Provider>
  );
};

// Custom hook to use the CountryContext easily
export const useCountry = () => useContext(CountryContext);
